import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(({ spacing }) => {
  return createStyles({
    gridContainer: {
      overflow: 'auto',
      height: '100%',
    },
    formWrapper: {
      width: '100%',
    },
    crosswalkContainer: {
      display: 'flex',
      flexDirection: 'column',
      paddingRight: spacing(2),
    },
    actionButton: {
      margin: spacing(),
    },
    actionButtons: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    fullHeight: {
      height: '100%',
    },
  });
});

export default useStyles;
